var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYodlee(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "481px",
    height: "162px",
    viewBox: "0 0 481 162",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Atoms / Logo / SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.1182676%",
    y1: "63.6380243%",
    x2: "0.677771608%",
    y2: "44.3336206%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9DDE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "97.7731707%",
    y1: "55.6739349%",
    x2: "-75.202439%",
    y2: "35.1267165%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9DDE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "230.6686%",
    y1: "108.888392%",
    x2: "2.20382302%",
    y2: "49.8959152%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9DDE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "227.811911%",
    y1: "80.1822609%",
    x2: "-0.0824764353%",
    y2: "44.5168924%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9DDE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "106.629195%",
    y1: "56.715427%",
    x2: "-66.5057022%",
    y2: "36.2208959%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64C2E7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84CCE5",
    offset: "34.3%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9FD8E4",
    offset: "74.97%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9DDE4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.3086248%",
    y1: "41.5102949%",
    x2: "-0.362021099%",
    y2: "53.466674%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.009918%",
    y1: "50.0076134%",
    x2: "-131.050237%",
    y2: "50.0076134%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "229.849656%",
    y1: "25.0976609%",
    x2: "-1.54252577%",
    y2: "54.5441014%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.3717073%",
    y1: "45.2343237%",
    x2: "-75.820813%",
    y2: "62.1520464%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.009869%",
    y1: "50.0023057%",
    x2: "-129.912465%",
    y2: "50.0023057%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "116.011805%",
    y1: "49.999341%",
    x2: "1.00021464%",
    y2: "49.999341%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "339.939937%",
    y1: "50.0125483%",
    x2: "2.92987421%",
    y2: "50.0125483%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "99.214565%",
    y1: "45.2445133%",
    x2: "-76.3101988%",
    y2: "62.2039103%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "231.655741%",
    y1: "8.61207698%",
    x2: "0.846615253%",
    y2: "49.8609621%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00548B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.009869%",
    y1: "49.9871542%",
    x2: "-129.912465%",
    y2: "49.9871542%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "115.873016%",
    y1: "50.0019763%",
    x2: "0.938652939%",
    y2: "50.0019763%",
    id: "linearGradient-16"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0086C3",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30AEE4",
    offset: "98.77%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Atoms-/-Logo-/-SVG",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Envestnet-Yodlee-logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(127.375926, 35.604396)",
    fill: "#0069AA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0.267222222 36.5212088 0.267222222 1.08593407 20.878963 1.08593407 20.878963 6.83604396 7.00122222 6.83604396 7.00122222 15.1585714 19.0974815 15.1585714 17.9217037 21.0065934 7.00122222 21.0065934 7.00122222 30.7710989 20.9235 30.7710989 20.9235 36.5212088"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.1475556 36.5212088 41.4461667 12.1232967 41.4461667 36.5212088 35.1219074 36.5212088 35.1219074 1.08593407 41.5441481 1.08593407 57.4795 24.3 57.4795 1.08593407 63.8037593 1.08593407 63.8037593 36.5212088"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.5675741 36.6725275 88.8870185 36.6725275 75.4635556 0.765494505 83.0348519 0.765494505 92.4856111 27.8871429 101.793852 1.08593407 108.884148 1.08593407"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.510333,36.9306593 C164.190241,36.9306593 160.493667,35.9604396 157.367167,34.4650549 L158.391519,28.2520879 C161.3755,29.9967033 165.072074,31.3852747 168.617222,31.3852747 C171.761537,31.3852747 173.91713,29.8987912 173.91713,27.0682418 C173.91713,24.4513187 172.679,23.3742857 167.539426,21.1668132 C160.645093,18.3451648 157.874889,16.0842857 157.874889,10.5834066 C157.874889,4.31703297 162.711611,0.667582418 169.34763,0.667582418 C173.355963,0.667582418 176.126167,1.48648352 178.700407,2.82164835 L177.676056,8.99010989 C175.101815,7.2989011 172.073296,6.21296703 169.294185,6.21296703 C165.90937,6.21296703 164.412926,7.85967033 164.412926,10.0137363 C164.412926,12.2746154 165.544167,13.3516484 170.469963,15.4078022 C177.774037,18.3807692 180.446259,20.8997802 180.446259,26.4006593 C180.437352,33.3346154 175.351222,36.9306593 168.510333,36.9306593 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.923241 6.98736264 208.923241 36.5212088 202.091259 36.5212088 202.091259 6.98736264 191.553796 6.98736264 191.553796 1.08593407 219.772463 1.08593407 218.436352 6.98736264"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "255.13487 36.5212088 238.433481 12.1232967 238.433481 36.5212088 232.109222 36.5212088 232.109222 1.08593407 238.54037 1.08593407 254.466815 24.3 254.466815 1.08593407 260.791074 1.08593407 260.791074 36.5212088"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "326.492111 6.98736264 326.492111 36.5212088 319.651222 36.5212088 319.651222 6.98736264 309.113759 6.98736264 309.113759 1.08593407 336.985037 1.08593407 335.648926 6.98736264"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "121.960222 36.45 121.960222 1.00582418 142.58087 1.00582418 142.58087 6.75593407 128.70313 6.75593407 128.70313 15.0784615 140.790481 15.0784615 139.614704 20.9353846 128.70313 20.9353846 128.70313 30.6998901 142.625407 30.6998901 142.625407 36.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "276.575 36.539011 276.575 1.09483516 297.195648 1.09483516 297.195648 6.84494505 283.317907 6.84494505 283.317907 15.1674725 295.405259 15.1674725 294.229481 21.0243956 283.317907 21.0243956 283.317907 30.7889011 297.240185 30.7889011 297.240185 36.539011"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(471.201852, 36.494505)",
    fill: "#0069AA"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.79218519,9.7110989 C2.0487037,9.7110989 0.151425926,7.81516484 0.151425926,4.97571429 C0.151425926,2.15406593 2.09324074,0.213626374 4.79218519,0.213626374 C7.52675926,0.213626374 9.43294444,2.13626374 9.43294444,4.97571429 C9.43294444,7.78846154 7.49112963,9.7110989 4.79218519,9.7110989 Z M4.79218519,0.756593407 C2.58314815,0.756593407 0.819481481,2.26978022 0.819481481,4.96681319 C0.819481481,7.64604396 2.58314815,9.15923077 4.79218519,9.15923077 C7.01903704,9.15923077 8.7827037,7.64604396 8.7827037,4.96681319 C8.7827037,2.26978022 7.00122222,0.756593407 4.79218519,0.756593407 Z M5.97687037,7.48582418 L4.58731481,5.42076923 L4.19538889,5.42076923 L4.19538889,7.42351648 L3.02851852,7.42351648 L3.02851852,2.17186813 L4.82781481,2.17186813 C6.03031481,2.17186813 6.76962963,2.74153846 6.76962963,3.76516484 C6.76962963,4.50395604 6.40442593,4.97571429 5.772,5.21604396 L7.17937037,7.2810989 L5.97687037,7.48582418 Z M4.74764815,3.10648352 L4.19538889,3.10648352 L4.19538889,4.59296703 L4.72983333,4.59296703 C5.28209259,4.59296703 5.60275926,4.35263736 5.60275926,3.83637363 C5.60275926,3.37351648 5.30881481,3.10648352 4.74764815,3.10648352 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79218519,9.7110989 C2.0487037,9.7110989 0.151425926,7.81516484 0.151425926,4.97571429 C0.151425926,2.15406593 2.09324074,0.213626374 4.79218519,0.213626374 C7.52675926,0.213626374 9.43294444,2.13626374 9.43294444,4.97571429 C9.43294444,7.78846154 7.49112963,9.7110989 4.79218519,9.7110989 Z M4.79218519,0.756593407 C2.58314815,0.756593407 0.819481481,2.26978022 0.819481481,4.96681319 C0.819481481,7.64604396 2.58314815,9.15923077 4.79218519,9.15923077 C7.01903704,9.15923077 8.7827037,7.64604396 8.7827037,4.96681319 C8.7827037,2.26978022 7.00122222,0.756593407 4.79218519,0.756593407 Z M5.97687037,7.48582418 L4.58731481,5.42076923 L4.19538889,5.42076923 L4.19538889,7.42351648 L3.02851852,7.42351648 L3.02851852,2.17186813 L4.82781481,2.17186813 C6.03031481,2.17186813 6.76962963,2.74153846 6.76962963,3.76516484 C6.76962963,4.50395604 6.40442593,4.97571429 5.772,5.21604396 L7.17937037,7.2810989 L5.97687037,7.48582418 Z M4.74764815,3.10648352 L4.19538889,3.10648352 L4.19538889,4.59296703 L4.72983333,4.59296703 C5.28209259,4.59296703 5.60275926,4.35263736 5.60275926,3.83637363 C5.60275926,3.37351648 5.30881481,3.10648352 4.74764815,3.10648352 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M425.008037,108.041538 C422.264556,108.041538 420.367278,106.145604 420.367278,103.306154 C420.367278,100.484505 422.309093,98.5440659 425.008037,98.5440659 C427.742611,98.5440659 429.648796,100.466703 429.648796,103.306154 C429.648796,106.118901 427.706981,108.041538 425.008037,108.041538 Z M425.008037,99.0959341 C422.799,99.0959341 421.035333,100.609121 421.035333,103.306154 C421.035333,105.985385 422.799,107.498571 425.008037,107.498571 C427.234889,107.498571 428.998556,105.985385 428.998556,103.306154 C428.998556,100.609121 427.217074,99.0959341 425.008037,99.0959341 Z M426.192722,105.816264 L424.803167,103.751209 L424.411241,103.751209 L424.411241,105.753956 L423.24437,105.753956 L423.24437,100.502308 L425.043667,100.502308 C426.246167,100.502308 426.985481,101.071978 426.985481,102.095604 C426.985481,102.834396 426.620278,103.306154 425.987852,103.546484 L427.395222,105.611538 L426.192722,105.816264 Z M424.972407,101.445824 L424.420148,101.445824 L424.420148,102.932308 L424.954593,102.932308 C425.506852,102.932308 425.827519,102.691978 425.827519,102.175714 C425.827519,101.712857 425.524667,101.445824 424.972407,101.445824 Z",
    id: "Shape",
    fill: "#0096D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(123.812963, 98.802198)",
    fill: "#0096D6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.3494074,0.427252747 L29.7596481,22.2972527 C29.4657037,22.6443956 29.1539444,23.0093407 29.0648704,23.1161538 C28.9757963,23.222967 28.904537,23.4098901 28.904537,23.5523077 C28.904537,23.6947253 28.904537,24.1664835 28.904537,24.6204396 L28.904537,34.8210989 C28.904537,35.2750549 28.5304259,35.6489011 28.0761481,35.6489011 L20.7809815,35.6489011 C20.3267037,35.6489011 19.9525926,35.2750549 19.9525926,34.8210989 L19.9525926,24.6204396 C19.9525926,24.1664835 19.9525926,23.6858242 19.9525926,23.5523077 C19.9525926,23.4187912 19.8813333,23.222967 19.7922593,23.1161538 C19.7031852,23.0093407 19.3914259,22.6443956 19.0974815,22.2972527 L1.04216667,1.05923077 C0.748222222,0.712087912 0.881833333,0.427252747 1.33611111,0.427252747 L10.1989815,0.427252747 C10.6532593,0.427252747 11.258963,0.712087912 11.5529074,1.06813187 L22.8742222,14.7936264 C23.1592593,15.1407692 23.6313519,15.7104396 23.9163889,16.0575824 C24.2014259,16.4047253 24.6646111,16.4047253 24.9496481,16.0575824 C25.2346852,15.7104396 25.6978704,15.1496703 25.9918148,14.7936264 L37.3131296,1.06813187 C37.5981667,0.720989011 38.2127778,0.427252747 38.6670556,0.427252747 L48.3494074,0.427252747",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9345,0.0089010989 C95.282537,0.0089010989 99.2997778,3.2489011 99.2997778,12.3814286 L99.2997778,23.6858242 C99.2997778,32.8183516 95.282537,36.0583516 83.9345,36.0583516 L65.2912963,36.0583516 C53.9432593,36.0583516 49.9260185,32.8183516 49.9260185,23.6858242 L49.9260185,12.3814286 C49.9260185,3.2489011 53.9432593,0.0089010989 65.2912963,0.0089010989 L83.9345,0.0089010989 M67.1796667,28.9908791 L82.055037,28.9908791 C87.1144444,28.9908791 90.0449815,27.5310989 90.0449815,20.0630769 L90.0449815,15.9774725 C90.0449815,11.34 89.0028148,7.04967033 81.4315185,7.04967033 L67.821,7.04967033 C60.2497037,7.04967033 59.2073589,11.34 59.2073589,15.9774725 L59.2073589,20.0630769 C59.1897222,25.7241758 60.4991111,28.9908791 67.1796667,28.9908791",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.600352,0.427252747 L241.01663,0.427252747 C241.470907,0.427252747 241.845019,0.801098901 241.845019,1.25505495 L241.845019,5.72340659 C241.845019,6.17736264 241.470907,6.55120879 241.01663,6.55120879 L214.160796,6.55120879 C213.706519,6.55120879 213.038463,6.55120879 212.664352,6.55120879 C212.290241,6.55120879 211.996296,6.85384615 211.996296,7.21879121 C211.996296,7.58373626 211.996296,8.26021978 211.996296,8.71417582 L211.996296,13.138022 C211.996296,13.591978 211.996296,14.2595604 211.996296,14.6334066 C211.996296,15.0072527 212.299148,15.300989 212.664352,15.300989 C213.029556,15.300989 213.706519,15.300989 214.160796,15.300989 L239.448926,15.300989 C239.903204,15.300989 240.277315,15.6748352 240.277315,16.1287912 L240.277315,19.6536264 C240.277315,20.1075824 239.903204,20.4814286 239.448926,20.4814286 L214.160796,20.4814286 C213.706519,20.4814286 213.038463,20.4814286 212.664352,20.4814286 C212.290241,20.4814286 211.996296,20.7840659 211.996296,21.149011 C211.996296,21.513956 211.996296,22.1904396 211.996296,22.6443956 L211.996296,27.0682418 C211.996296,27.5221978 211.996296,28.1897802 211.996296,28.5636264 C211.996296,28.9285714 212.299148,29.2312088 212.664352,29.2312088 C213.029556,29.2312088 213.706519,29.2312088 214.160796,29.2312088 L241.7025,29.2312088 C242.156778,29.2312088 242.530889,29.6050549 242.530889,30.059011 L242.530889,34.8389011 C242.530889,35.2928571 242.156778,35.6667033 241.7025,35.6667033 L203.872741,35.6667033 C203.418463,35.6667033 203.044352,35.2928571 203.044352,34.8389011 L203.044352,1.24615385 C203.044352,0.792197802 203.418463,0.418351648 203.872741,0.418351648 L235.155556,0.418351648 C235.609833,0.418351648 236.349148,0.418351648 236.803426,0.418351648 L241.836111,0.418351648",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.480037,0.427252747 L287.896315,0.427252747 C288.350593,0.427252747 288.724704,0.801098901 288.724704,1.25505495 L288.724704,5.72340659 C288.724704,6.17736264 288.350593,6.55120879 287.896315,6.55120879 L261.040481,6.55120879 C260.586204,6.55120879 259.918148,6.55120879 259.544037,6.55120879 C259.178833,6.55120879 258.875981,6.85384615 258.875981,7.21879121 C258.875981,7.58373626 258.875981,8.26021978 258.875981,8.71417582 L258.875981,13.138022 C258.875981,13.591978 258.875981,14.2595604 258.875981,14.6334066 C258.875981,15.0072527 259.178833,15.300989 259.544037,15.300989 C259.909241,15.300989 260.586204,15.300989 261.040481,15.300989 L286.328611,15.300989 C286.782889,15.300989 287.157,15.6748352 287.157,16.1287912 L287.157,19.6536264 C287.157,20.1075824 286.782889,20.4814286 286.328611,20.4814286 L261.040481,20.4814286 C260.586204,20.4814286 259.918148,20.4814286 259.544037,20.4814286 C259.178833,20.4814286 258.875981,20.7840659 258.875981,21.149011 C258.875981,21.513956 258.875981,22.1904396 258.875981,22.6443956 L258.875981,27.0682418 C258.875981,27.5221978 258.875981,28.1897802 258.875981,28.5636264 C258.875981,28.9285714 259.178833,29.2312088 259.544037,29.2312088 C259.909241,29.2312088 260.586204,29.2312088 261.040481,29.2312088 L288.582185,29.2312088 C289.036463,29.2312088 289.410574,29.6050549 289.410574,30.059011 L289.410574,34.8389011 C289.410574,35.2928571 289.036463,35.6667033 288.582185,35.6667033 L250.752426,35.6667033 C250.298148,35.6667033 249.924037,35.2928571 249.924037,34.8389011 L249.924037,1.24615385 C249.924037,0.792197802 250.298148,0.418351648 250.752426,0.418351648 L282.044148,0.418351648 C282.498426,0.418351648 283.237741,0.418351648 283.692019,0.418351648 L288.724704,0.418351648",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.815407,0.427252747 L135.526204,0.427252747 L127.812389,0.427252747 L122.940037,0.427252747 L107.120481,0.427252747 L107.120481,35.64 L122.940037,35.64 L127.812389,35.64 L137.815407,35.64 C148.878407,35.64 155.247204,26.8012088 155.247204,18.4430769 L155.247204,17.6241758 C155.247204,9.26604396 148.878407,0.427252747 137.815407,0.427252747 Z M145.627204,18.1493407 C145.627204,24.1130769 141.37837,28.5814286 133.459685,28.5814286 L127.812389,28.5814286 L122.940037,28.5814286 L117.408537,28.5814286 L116.072426,28.5814286 L116.072426,27.2462637 L116.072426,8.50945055 L116.072426,7.17428571 L117.408537,7.17428571 L122.940037,7.17428571 L127.812389,7.17428571 L133.459685,7.17428571 C141.494167,7.17428571 145.627204,11.5536264 145.627204,17.6063736 L145.627204,18.1493407 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.835167,2.74153846 C170.835167,2.98186813 170.826259,3.55153846 170.826259,4.00549451 L170.835167,26.4184615 C170.835167,26.8724176 170.835167,27.54 170.835167,27.9138462 C170.835167,28.2787912 171.138019,28.5814286 171.503222,28.5814286 C171.868426,28.5814286 172.545389,28.5814286 172.999667,28.5814286 L196.141111,28.5814286 C196.595389,28.5814286 196.9695,28.9552747 196.9695,29.4092308 L196.9695,34.8210989 C196.9695,35.2750549 196.595389,35.6489011 196.141111,35.6489011 L162.711611,35.6489011 C162.257333,35.6489011 161.883222,35.2750549 161.883222,34.8210989 L161.883222,1.24615385 C161.883222,0.792197802 162.257333,0.418351648 162.711611,0.418351648 L170.006778,0.418351648 C170.461056,0.418351648 170.835167,0.792197802 170.835167,1.24615385 L170.835167,1.47758242 C170.835167,1.93153846 170.835167,2.50120879 170.835167,2.74153846 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-1)",
    points: "0.774944444 0.409450549 0.774944444 27.4242857 55.510963 47.9947253 97.0283889 36.5746154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-2)",
    points: "55.510963 83.6436264 97.0283889 72.2235165 83.7741667 67.2389011 42.2478333 78.659011"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-3)",
    points: "0.774944444 36.0494505 0.774944444 63.0464835 42.2478333 51.6441758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-4)",
    points: "29.1005 82.2728571 0.774944444 90.0702198 0.774944444 98.6597802 0.828388889 98.6775824 42.3547222 87.2574725"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-5)",
    points: "55.7158333 119.176813 97.0283889 107.81011 97.0283889 107.801209 83.8810556 102.861099 42.3547222 114.281209"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-6)",
    points: "0.774944444 134.281978 0.774944444 161.181099 97.0283889 134.709231 97.0283889 134.70033 55.7158333 119.176813"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-7)",
    points: "97.0283889 134.70033 97.0283889 107.81011 55.7158333 119.176813"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-8)",
    points: "42.2478333 78.659011 0.774944444 63.0731868 0.774944444 71.6271429 29.1005 82.2728571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-9)",
    points: "55.510963 47.9947253 42.2478333 51.6441758 83.7741667 67.2389011 97.0283889 63.5983516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-10)",
    points: "97.0283889 36.5746154 55.510963 47.9947253 97.0283889 63.5983516"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-11)",
    points: "0.774944444 63.0464835 0.774944444 63.0731868 42.2478333 78.659011 83.7741667 67.2389011 42.2478333 51.6441758"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-12)",
    points: "0.774944444 71.6271429 0.774944444 90.0702198 29.1005 82.2728571"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-13)",
    points: "42.3547222 87.2574725 83.8810556 102.861099 97.0283889 99.2472527 55.510963 83.6436264"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-14)",
    points: "0.774944444 98.6953846 0.774944444 125.71022 42.3547222 114.281209 0.828388889 98.6775824"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-15)",
    points: "97.0283889 99.2472527 97.0283889 72.2235165 55.510963 83.6436264"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "url(#linearGradient-16)",
    points: "0.828388889 98.6775824 42.3547222 114.281209 83.8810556 102.861099 42.3547222 87.2574725"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYodlee);
export default __webpack_public_path__ + "static/media/yodlee.f22c5ba7.svg";
export { ForwardRef as ReactComponent };